"use client"

import Navlinks from './Navlinks';
import { useState } from "react";
import { Dictionary, Locales } from "@/app/[lang]/dictonaries";

export default function Navbar({ dict, lang }: { dict: Dictionary, lang: Locales }) {
    const [pressed, setPressed] = useState<boolean>(false);

    // `hoveredLink` and the onMouseLeave that reset it existed only to drive
    // the Plans and Explore dropdown panels, both now removed.
    return (
        <nav
            className={"js-site-navbar fixed w-full top-0 bg-transparent z-40 min-h-20 pt-6"}>
            <div
                className={
                    `flex lg:pl-4 pl-2 pr-2 lg:pr-2 max-w-5xl w-11/12 
                    mx-auto backdrop-blur-3xl overflow-hidden backdrop-brightness-75 
                    transition-[max-height,border-radius] duration-300 ease-in-out 
                    will-change-[max-height,border-radius] rounded-[30px]`}>
                <Navlinks dict={dict} lang={lang} setPressed={setPressed} pressed={pressed}
                    onPress={() => setPressed(!pressed)} />
            </div>
        </nav>
    );
}